import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetCurrenciesRepoType, IGetCurrenciesRepo } from '../../repos';

export const useCurrenciesTableContext = () => {
  const getCurrenciesOperationsRepo = useService<IGetCurrenciesRepo>(GetCurrenciesRepoType);

  const onFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getCurrenciesOperationsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getCurrenciesOperationsRepo],
  );

  return { onFetch };
};
